<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header
        elevated
        style="
          background: rgba(25, 118, 210, 0.35);
          box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          z-index: 4;
        "
      >
        <q-toolbar>
          <q-btn dense flat round icon="menu" @click="toggleLeftDrawer" />

          <q-toolbar-title>
            <img
              class="q-pa-sm q-pl-md"
              src="./assets/lichtenstein.png"
              style="height: 70px; width: 180px"
            />
          </q-toolbar-title>
        </q-toolbar>
      </q-header>

      <q-drawer show-if-above v-model="leftDrawerOpen" side="left" bordered>
        <div class="q-pa-md full-height">
          <div class="column items-center q-gutter-y-lg q-mt-md">
            <q-avatar id="user_avatar" size="100px">
              <img
                v-if="!isAuthed"
                src="./assets/asptmr-1.png"
              />
              <img v-else :src="user_picture" />
            </q-avatar>
            <h6 class="col" v-if="isAuthed">{{ username }}</h6>
            <!-- <h6 class="col" v-else>{{ t("guest.username") }}</h6> -->
            <router-link to="/" v-if="!isAuthed">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.dashboard')"
                icon="dashboard"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            <router-link to="dashboard" v-if="isAuthed">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.dashboard')"
                icon="dashboard"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            <router-link to="despre">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.despre')"
                icon="chat"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            <div @click="Redirect('https://asptmr-maps.web.app')">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.maps')"
                icon="map"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </div>
            <router-link v-if="isAuthed && isadmin" to="adminchat">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.chat')"
                icon="question_answer"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            <router-link to="resources">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.resources')"
                icon="menu_book"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            <!-- <router-link to="intrebari">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.faq')"
                icon="help"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link> -->
            <router-link to="forum">
              <q-btn
                class="col btn-fixed-width"
                flat
                align="left"
                color="blue-8"
                :label="t('navbar.forum')"
                icon="mdi-account-group"
                style="width: 250px;border-bottom:2px solid #1976d2"
                size="22px"
              ></q-btn>
            </router-link>
            
          </div>

          <div id="copyright" class="column items-center q-mt-xl">
            <div class="row items-center justify-center">
              <img style="height: 18px" src="./assets/ro.svg" />
              <q-toggle
                v-model="languageSelect"
                false-value="ro"
                true-value="en"
              />
              <img style="height: 18px" src="./assets/en.svg" />
            </div>
            <!-- <q-btn
              type="primary"
              color="green-8"
              v-if="!isAuthed"
              to="/sign-in"
              class="full-width q-mt-md"
              >{{ t("navbar.signin") }}</q-btn
            >
            <q-btn
              type="primary"
              color="blue-10"
              v-if="!isAuthed"
              to="/register"
              class="full-width"
              >{{ t("navbar.register") }}</q-btn
            > -->
            <q-btn-dropdown
              v-if="isAuthed"
              class="flat q-mt-sm"
              color="blue-8"
              :label="t('navbar.setting')"
            >
              <div class="row no-wrap q-pa-md">
                <div class="column">
                  <div class="text-h6 q-mb-md">{{ t("navbar.setting") }}</div>
                  <q-btn-toggle
                    v-model="languageSelect"
                    push
                    toggle-color="blue-6"
                    :options="[
                      { label: 'English', value: 'en' },
                      { label: 'Romanian', value: 'ro' },
                    ]"
                  />
                  <br />
                  <q-btn
                    :label="t('navbar.settings.changepic')"
                    color="primary"
                    @click="changepic = true"
                    class="q-mt-sm"
                  />
                </div>

                <q-separator vertical inset class="q-mx-lg" />

                <div class="column items-center">
                  <q-avatar size="55px">
                    <img :src="user_picture" />
                  </q-avatar>

                  <div class="text-subtitle1 q-mt-md q-mb-xs">
                    {{ username }}
                  </div>

                  <q-btn
                    color="primary"
                    :label="t('navbar.logout')"
                    push
                    size="sm"
                    v-close-popup
                    @click="sendLogout()"
                  />
                </div>
              </div>
            </q-btn-dropdown>
          </div>
        </div>
      </q-drawer>
      <q-page-container>
        <q-dialog v-model="changepic">
          <q-card>
            <q-card-section>
              <div class="text-h6">Incarca imaginea</div>
              <q-file
                v-model="imageData"
                label="Pick one file"
                filled
                style="max-width: 300px"
                max-total-size="4194304"
              />
              <q-linear-progress
                stripe
                :value="uploadValue"
                size="25px"
                rounded
                color="secondary"
                class="q-mt-sm"
              />
            </q-card-section>
            <q-card-section v-if="imageData != null">
              <img class="preview" :src="picture" />
              <q-btn
                size="md"
                @click="onUpload()"
                color="blue-8"
                rounded
                icon="mdi-upload"
                label="Incarca"
                class="q-mt-md"
              />

              <q-btn
                size="md"
                @click="changepic = false"
                color="red-8"
                rounded
                icon="mdi-close"
                class="q-mt-md"
              />
            </q-card-section>
          </q-card>
        </q-dialog>
        <router-view class="animate__animated animate__fadeIn"/>
      </q-page-container>
      <chat />
    </q-layout>
    <q-dialog v-model="cookies" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <img src="./assets/cookies.svg" style="width: 8rem" />
          <div class="text-h5 text-bold" style="color: #303030">
            {{ t("cookies.title") }}
          </div>
        </q-card-section>
        <q-separator inset />
        <q-card-section class="row" style="color: #303030">
          {{ t("cookies.content") }}
        </q-card-section>
        <q-card-actions align="right">
          <!-- <q-btn color="green-10" @click="cookies = false" flat>{{t('cookies.see')}}</q-btn> -->
          <q-btn color="blue-8" @click="cookies = false">{{
            t("cookies.close")
          }}</q-btn></q-card-actions
        >
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import i18n from "./i18n";
import firebase from "firebase";
// import { Notify } from "quasar";
import Chat from "./components/chat/Chat.vue";
import { store } from "./store/store";
import { Notify } from "quasar";

export default {
  components: { Chat },
  setup() {
    const leftDrawerOpen = ref(false);
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return {
      leftDrawerOpen,
      toggleLeftDrawer() {
        leftDrawerOpen.value = !leftDrawerOpen.value;
      },
      languageSelect: ref(i18n.global.locale),
      t,
    };
  },

  data() {
    return {
      username: "",
      isAuthed: false,
      user_picture: "https://i.imgur.com/92ibtIJ.png",
      changepic: ref(false),
      imageData: null,
      picture: null,
      uploadValue: 0,
      savedData: false,
      cookies: true,
      isadmin: store.state.user.isadmin,
    };
  },
  methods: {
    Redirect(link){
      window.location.href = link;
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    },
    onUpload() {
      const user_uid = firebase.auth().currentUser.uid;
      const accepted_format = [
        "image/gif",
        "image/jpeg",
        "image/png",
        "image/jpg",
      ];
      const file_size = Math.round(this.imageData.size / 1024);
      const file_limit = 4 * 1024; // 4 mb
      // console.log('File type', this.imageData.type)
      if (file_size <= file_limit) {
        if (accepted_format.includes(this.imageData.type)) {
          this.picture = null;
          const storageRef = firebase
            .storage()
            .ref(`profile_pics/${user_uid}/profile_img`)
            .put(this.imageData);
          storageRef.on(
            `state_changed`,
            (snapshot) => {
              this.uploadValue =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              Notify.create({
                color: "red",
                message: `${error.message}`,
                icon: "mdi-alert-circle",
              });
            },
            () => {
              Notify.create({
                color: "green",
                message: "Fisierul a fost incarcat",
                icon: "mdi-checkbox-marked",
              });
              this.uploadValue = 100;
              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                firebase
                  .database()
                  .ref("users/" + user_uid)
                  .update({ profilepic: url });
                this.user_picture = url;
                this.picture = url;
              });
            }
          );
        } else {
          Notify.create({
            color: "red",
            message: "Acest tip de fisier nu este acceptat",
            icon: "mdi-alert-circle",
          });
        }
      } else {
        Notify.create({
          color: "red",
          message: "Fisierul este prea mare!",
          icon: "mdi-alert-circle",
        });
      }
    },
    sendLogout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          firebase.auth().onAuthStateChanged(() => {
            store.commit({
              type: "UPDATE_ADMIN",
              status: false,
            });
            this.$router.push({ name: "Home" });
            setTimeout(() => {
              location.reload();
            }, 2000);
          });
        });
    },

    CheckAdmin() {
      const user = firebase.auth().currentUser;
      if (user) {
        const uid = user.uid;
        const user_db = firebase.database().ref("users/" + uid);
        user_db.get().then((data) => {
          const user_data = data.val();
          if (user_data.admin) {
            // console.log("Okay")
            this.isadmin = true;
            store.commit({
              type: "UPDATE_ADMIN",
              status: true,
            });
          } else this.isadmin = false;
          store.commit({
            type: "UPDATE_ADMIN",
            status: false,
          });
        });
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.isAuthed = store.state.user.loggedIn;

      if (this.isAuthed && this.savedData == false) {
        this.savedData = true;
        if (firebase.auth().currentUser != null) {
          this.username = firebase.auth().currentUser.displayName;
          if (store.state.user.data == null) {
            const user = firebase.auth().currentUser;
            if (user) {
              const uid = user.uid;
              firebase
                .database()
                .ref("users/" + uid)
                .get()
                .then((snapshot) => {
                  const data = snapshot.val();
                  data.uid = uid;
                  store.commit({
                    type: "SET_USER",
                    data: data,
                  });
                  // console.log("Data sent")
                });
              // console.log("s-a ajuns aici");
            }
          }
        }
      }
    }, 1000);
    firebase.analytics();
    setTimeout(() => {
      this.CheckAdmin();
    }, 2000);
  },
};
</script>

<style>
.frosted {
  background: #ffffff99;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.hbckg {
  background: #c7c6c634;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

img.preview {
  width: 200px;
}

input::-webkit-file-upload-button {
  background: red;
}
</style>